<template>
  <div style="min-width: 1300px;padding: 50px 8%;">
  	<p style="text-align: center;font-size: 30px;">合作机构</p>
  	<p style="text-align: center;font-size: 15px;">Cooperation agency</p>
  	<agencylist style="margin: 50px 0;"></agencylist>
  </div>
</template>

<script>
//引入代理机构列表
import agencylist from '@/view/index/data/agencylist.vue'
export default {
  name: 'service',
  data:function(){
  	return {
  	}
  },
	components: {
		agencylist:agencylist
	},
	methods:{
	}
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/view/v2/index/agencylist/index.vue